import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class CombosHomeService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }
    /**
   * Description: Método que llama el servicio web que obtiene los COMBOS recomendados
   * Autor: Steven Sterling
   * @param category indica si el combo es recomendado o no 
   * @return Listado de combos
   * @modifiedBy Julian Ciro Barrera
   * Description: se implementa el consumo de servicios con el serviceCallUtilService
   */
  getCombosList(category) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_COMBO_RECOMMENDED, category);
  }


    /**
   * Description: Método que llama el servicio web que obtiene los bonos recomendados
   * Autor: Steven Sterling
   * @param category indica si el combo es recomendado o no 
   * @return Listado de combos
   * @modifiedBy Julian Ciro Barrera
   * Description: se implementa el consumo de servicios con el serviceCallUtilService
   */
  getBonusesList(category) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_BONUS_RECOMMENDED, category);
  }  
}
